<template>
    <div class="header">
      <ul class="nav warp">
        <li><a href="/">首页</a></li>
        <li><a href="/search">图片识别</a></li>
        <li><a href="/store">充值中心</a></li>
        <li><a href="/my?page=searching">个人中心</a></li>
      </ul>
      <span style="float:right;color:#fff;margin-right:20px;margin-top:-30px;cursor:pointer" @click="logout">退出</span>
    </div>
</template>
<script>
import {logoutApi} from '@/service/allApi'
export default {
  data(){return{}},
  methods:{
    async logout(){
      const res = logoutApi()
      localStorage.removeItem("user")
      this.$router.push("/login")
    }
  }
}
</script>
<style scoped src="../../../static/css/Common.css"></style>
<style scoped>
a{
  text-decoration: none;
}
ul{
  padding:0px;
  margin: 0px;
}
ul li{
  float: left;
  list-style: none;
}
.header{
	height: 80px;
	background-color: #5353ce;
  min-width: 1227px;
  text-align: center;
}
.header .nav{

  height: 35px;
  padding-top: 20px;
	font-size: 26px;
	color: #ffffff;
  width: 850px;

}
.header .nav li{
  width: 25%;
  text-align: center;
}
.header .nav li a{
  color:white;
}
</style>


// WEBPACK FOOTER //
// src/components/area/Navigation.vue